// Loaded by both the popup and the footer form, so it can run twice per page - hence the guard.

(function () {
  if (window.KlaviyoNewsletter) return;

const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
const KLAVIYO_REVISION = '2025-01-15';

const KLAVIYO_COMPANY_ID = 'PGBqty';
const KLAVIYO_LIST_ID = 'HgMuqZ';
const KLAVIYO_SMS_LIST_ID = 'Vpbw7W';

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

async function postSubscription(profileAttributes, subscriptions, listId, source) {
  const response = await fetch(
    `${KLAVIYO_ENDPOINT}?company_id=${encodeURIComponent(KLAVIYO_COMPANY_ID)}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: KLAVIYO_REVISION,
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Newsletter',
            profile: {
              data: { type: 'profile', attributes: { ...profileAttributes, subscriptions } },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      }),
    }
  );

  if (response.status !== 202) throw new Error(`Klaviyo responded ${response.status}`);
}

window.KlaviyoNewsletter = {
  companyId: KLAVIYO_COMPANY_ID,
  defaultListId: KLAVIYO_LIST_ID,
  defaultSmsListId: KLAVIYO_SMS_LIST_ID,

  isValidEmail(value) {
    return EMAIL_PATTERN.test(String(value).trim());
  },

  /** Klaviyo requires E.164 (+15551234567). */
  normalizePhone(value, countryCode = '') {
    const trimmed = String(value).trim();
    const digits = trimmed.replace(/\D/g, '');
    if (!digits) return '';
    if (trimmed.startsWith('+') || !countryCode) return `+${digits}`;
    // E.164 drops the national trunk 0 (UK 07911... -> +447911...); Italy keeps it
    const national = countryCode === '+39' ? digits : digits.replace(/^0/, '');
    return `${countryCode}${national}`;
  },

  /** E.164 allows 15 digits max; no country goes below 7. */
  isValidPhone(e164) {
    const length = String(e164).replace(/\D/g, '').length;
    return length >= 7 && length <= 15;
  },

  // One request per list: a subscription request can only name one.
  async subscribe({ email, phone, listId, smsListId, source, channels, properties } = {}) {
    const profile = {};
    if (email) profile.email = email;
    if (phone) profile.phone_number = phone;
    if (properties && Object.keys(properties).length) profile.properties = properties;

    const consent = { marketing: { consent: 'SUBSCRIBED' } };

    // Sequential: concurrent requests for a new shopper can each create a profile.
    const wants = (channel) => !channels || channels.includes(channel);

    if (email && wants('email')) {
      await postSubscription(profile, { email: consent }, listId || KLAVIYO_LIST_ID, source);
    }
    if (phone && wants('sms')) {
      await postSubscription(profile, { sms: consent }, smsListId || KLAVIYO_SMS_LIST_ID, source);
    }
    return true;
  },
};
})();
